/**
 * PortOne 결제 객체(PaidPayment)가 솜니아 슬립케어 주문인지 검증
 * (routes/payment.js 의 verifyPayment 와 역할은 유사하나, 클라이언트 전용)
 */
import { SLEEP_CARE_ORDER_NAME } from '../config/portoneSleepCare';

export function parsePortOneCustomData(customDataStr) {
  if (customDataStr == null || customDataStr === '') return null;
  try {
    return typeof customDataStr === 'string' ? JSON.parse(customDataStr) : customDataStr;
  } catch {
    return null;
  }
}

/**
 * @param {object} payment — PortOne getPayment 응답( PaidPayment 등 )
 * @param {{ customerEmail?: string }} [opts]
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateSleepCarePortOnePayment(payment, opts = {}) {
  if (!payment || typeof payment !== 'object') {
    return { ok: false, message: '결제 정보가 없습니다.' };
  }

  if (payment.status !== 'PAID') {
    return { ok: false, message: `결제가 완료 상태가 아닙니다 (${payment.status || 'unknown'}).` };
  }

  if (payment.orderName !== SLEEP_CARE_ORDER_NAME) {
    return { ok: false, message: '주문명이 슬립케어 상품과 일치하지 않습니다.' };
  }

  if (payment.currency !== 'KRW') {
    return { ok: false, message: '통화가 KRW 가 아닙니다.' };
  }

  const cd = parsePortOneCustomData(payment.customData);
  if (!cd || cd.product !== 'sleepcare') {
    return { ok: false, message: 'customData 가 슬립케어 결제가 아닙니다.' };
  }

  const total = payment.amount?.total != null ? Number(payment.amount.total) : null;
  if (total == null || Number.isNaN(total)) {
    return { ok: false, message: '결제 금액 정보를 확인할 수 없습니다.' };
  }

  const expected = cd.expectedAmount != null ? Number(cd.expectedAmount) : null;
  if (expected != null && !Number.isNaN(expected) && expected !== total) {
    return { ok: false, message: '결제 금액이 사전 요청 금액과 일치하지 않습니다.' };
  }

  const email = opts.customerEmail;
  if (email && payment.customer?.email) {
    if (String(payment.customer.email).toLowerCase() !== String(email).toLowerCase()) {
      return { ok: false, message: '결제에 사용된 이메일이 로그인 계정과 일치하지 않습니다.' };
    }
  }

  return { ok: true, customData: cd, total };
}

/** sessionStorage pending 의 rawCustomData 가 슬립케어인지 */
export function isSleepCarePendingCustomData(rawCustomData) {
  if (!rawCustomData || typeof rawCustomData !== 'object') return false;
  return rawCustomData.product === 'sleepcare';
}
